import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "is-size-4 mb-4" }
const _hoisted_2 = { style: {height: '90vh'} }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "bold-text" }, "Selected Plan:", -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.selectedPlan.title), 1)
    ]),
    _createElementVNode("button", {
      class: "button is-primary mb-3 bold-text",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backBtnClick && _ctx.backBtnClick(...args)))
    }, "Change Selection"),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("iframe", {
        allow: "payment",
        src: _ctx.iframeSrc,
        style: {width: '100%', height: '100%'}
      }, null, 8, _hoisted_3)
    ])
  ], 64))
}